import { useRouter } from 'expo-router';
import { ArrowLeft } from 'lucide-react-native';
import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { PremiumFooter } from '../src/components/landing/PremiumFooter';
import { Container } from '../src/components/primitives/Container';
import { Text } from '../src/components/primitives/Text';
import { useTranslation } from '../src/contexts/TranslationContext';
import { colors } from '../src/theme/colors';
import { spacing } from '../src/theme/spacing';

export default function AboutPage() {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <Container maxWidth="md">
        <Pressable
          testID="about-back-button"
          onPress={() => router.push('/landing')}
          style={styles.backButton}
          accessibilityRole="button"
          accessibilityLabel={t('common.actions.goBack')}
        >
          <ArrowLeft size={20} color={colors.primary[500]} />
          <Text variant="bodySmall" color={colors.primary[500]}>
            {t('common.actions.goBack')}
          </Text>
        </Pressable>

        <View style={styles.header}>
          <Text testID="about-heading" variant="h1" style={styles.title}>
            {t('marketing.about.heading')}
          </Text>
        </View>

        <View style={styles.divider} />

        <View testID="about-placeholder" style={styles.placeholder}>
          <Text variant="body" color={colors.text.tertiary} style={styles.placeholderText}>
            {t('marketing.about.placeholder')}
          </Text>
        </View>
      </Container>

      <PremiumFooter />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
  content: {
    flexGrow: 1,
    paddingTop: Platform.select({ web: 60, default: 40 }),
    paddingBottom: spacing.xxl,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    marginBottom: spacing.xl,
    alignSelf: 'flex-start',
  },
  header: {
    marginBottom: spacing.lg,
    gap: spacing.sm,
  },
  title: {
    fontSize: Platform.select({ web: 42, default: 32 }),
    fontWeight: '700',
    letterSpacing: -0.5,
  },
  divider: {
    height: 1,
    backgroundColor: colors.border.muted,
    marginBottom: spacing.xxl,
  },
  placeholder: {
    borderWidth: 2,
    borderColor: colors.border.muted,
    borderStyle: 'dashed',
    borderRadius: 8,
    padding: spacing.xl,
    alignItems: 'center',
    marginBottom: spacing.xxl,
  },
  placeholderText: {
    textAlign: 'center',
    fontStyle: 'italic',
  },
});
